<template lang="pug">
    .trainer-title-wrapper(:class="'context-'+context")
        include TrainerTitle.pug
</template>

<script>
import _ from "underscore";
import { mapState } from 'vuex';

export default {
  name: 'TrainerTitle',
  props: [
    "titleName", "status", "cecObject", "mode", "prefixed",
    "extended", "extraText", "document", "subtitleName",
    "plan",
  ],
  computed: mapState([
    "context",
  ]),
  data() {
    // Data contained on the component
    return {
      hasDetail :false,
      cecIcon: null,
      detailVisibleCec: false,
    };
  },
  mounted() {
    console.log(this.titleName);
    console.log(this.plan);
    console.log(this.status);
    console.log("----");
    if (this.cecObject) this.addCecIcon();
  },
  methods: {
    toggleDetailCec() {
      this.detailVisibleCec = !this.detailVisibleCec;
    },
    addCecIcon() {
      const v2 = _.has(this.cecObject, 'elearning_category')

      // V1
      if (!v2) {
        if (this.cecObject && this.cecObject.level_course) {
          let levelCourse = this.cecObject.level_course;
          if (_.isNumber(levelCourse.cecs)) {
            this.hasDetail = true;
            this.cecIcon = `/static/icons/CECs-num-ok-${levelCourse.cecs}.png`;
          }
        }
      } else {
        // V2
        const level = this.cecObject.level
      }
    }
  },
  filters: {
    cecsubcategory: function(value) {
      const v2 = _.has(value, 'elearning_category')

      if (!v2) {
        // V1
        let levelCourse = value.level_course;
        // TODO: Only fetching the first subcategory?
        return _.first(levelCourse.subcategories).name;
      } else {
        // V2
        if (value.elearning_category) return value.elearning_category
        return "~"
      }
    }
  },
  watch: {
    cecObject: function(newValue) {
      if (newValue) this.addCecIcon();
    }
  }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "TrainerTitle";

.context-colreps {
    @import "TrainerTitleColreps";
}
</style>



// WEBPACK FOOTER //
// src/components/trainer_title/TrainerTitle.vue